import React, { useState } from 'react';
import { ChevronDown, CheckSquare, ClipboardList, LayoutGrid, BarChart3, BookOpen, HeartPulse } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function Bonos() {
  const bonos = [{
    num: 1,
    icon: CheckSquare,
    title: 'Checklist técnica zurda fundamental',
    desc: 'PDF imprimible con 8 puntos de autoevaluación por golpe para revisar tu técnica zurda antes y después de cada práctica.',
    resultado: 'Sabés exactamente en qué aspecto de tu técnica zurda enfocarte cada día.',
    valor: '$3.990'
  }, {
    num: 2,
    icon: ClipboardList,
    title: 'Hoja de puntaje y notas tácticas por partido',
    desc: 'PDF rellenable para registrar goles, asistencias, regates y decisiones tácticas de cada partido jugado.',
    resultado: 'Tomás decisiones con datos reales sobre tu evolución como zurdo.',
    valor: '$2.490'
  }, {
    num: 3,
    icon: LayoutGrid,
    title: 'Diagrama de posicionamiento zurdo en fútbol 5',
    desc: '20 diagramas de cancha con las posiciones y movimientos óptimos para el jugador zurdo en cada situación táctica del fútbol 5.',
    resultado: 'Siempre sabés dónde estar y hacia dónde moverte según la jugada.',
    valor: '$2.990'
  }, {
    num: 4,
    icon: BarChart3,
    title: 'Tabla de estadísticas personales',
    desc: 'Sistema de seguimiento de progreso durante 30 días con métricas específicas para el zurdo: goles, asistencias, regates y uso de pierna derecha.',
    resultado: 'Medís tu evolución real semana a semana con datos concretos.',
    valor: '$1.990'
  }, {
    num: 5,
    icon: BookOpen,
    title: 'Glosario del fútbol 5 zurdo: 40 términos esenciales',
    desc: 'PDF ilustrado con el vocabulario táctico y técnico que todo zurdo de fútbol 5 necesita conocer para comunicarse mejor con su equipo y entender al entrenador.',
    resultado: 'Entendés el juego a otro nivel y te comunicás mejor dentro de la cancha.',
    valor: '$3.490'
  }, {
    num: 6,
    icon: HeartPulse,
    title: 'Rutina de calentamiento y prevención de lesiones para zurdos',
    desc: '10 ejercicios pre-partido ilustrados paso a paso para proteger tobillo, rodilla y cadera izquierda, las zonas de mayor riesgo en el zurdo que sobrecarga su pierna dominante.',
    resultado: 'Jugás sin miedo a lesionarte y llegás a cada partido con tu zurda lista al 100%.',
    valor: '$4.990'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-celeste relative" data-id="element-17">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-18">
        <FadeIn data-id="element-19">
          <div className="text-center mb-10" data-id="element-20">
            <h3 className="font-display text-white font-bold tracking-widest uppercase mb-2" data-id="element-21">
              6 BONOS EXCLUSIVOS INCLUIDOS
            </h3>
            <h2 className="font-display text-3xl md:text-4xl font-black mb-4 uppercase text-navy" data-id="element-22">
              Bonos por tiempo limitado
            </h2>
            <p className="text-navy/80 font-medium mb-2" data-id="element-23">
              Tocá cada bono para ver el contenido completo.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-10" data-id="element-24">
          {bonos.map((bono, idx) => {
          const isOpen = openIndex === idx;
          return <FadeIn key={idx} delay={idx * 0.05} data-id="element-25">
                <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow" data-id="element-26">
                  <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:bg-gray-50 transition-colors" data-id="element-27">
                    <div className="flex items-center gap-4 pr-4" data-id="element-28">
                      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gold/10 text-gold flex-shrink-0" data-id="element-29">
                        <bono.icon className="w-6 h-6" data-id="element-30" />
                      </div>
                      <div data-id="element-31">
                        <div className="flex items-center gap-2 mb-1" data-id="element-32">
                          <span className="text-navy font-display font-bold text-xs tracking-widest uppercase" data-id="element-33">
                            BONO {bono.num}
                          </span>
                          <span className="bg-gold text-white text-[10px] font-bold uppercase px-2 py-0.5 rounded-full" data-id="element-34">
                            GRATIS
                          </span>
                        </div>
                        <h3 className="font-bold text-navy text-base sm:text-lg leading-tight" data-id="element-35">
                          {bono.title}
                        </h3>
                      </div>
                    </div>
                    <ChevronDown className={`w-5 h-5 text-navy flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-36" />
                  </button>

                  <AnimatePresence data-id="element-37">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-38">
                        <div className="px-6 pb-6 pt-2" data-id="element-39">
                          <div className="border-t border-gray-200 pt-4 space-y-4" data-id="element-40">
                            <div data-id="element-41">
                              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-42">
                                <span className="font-bold text-navy" data-id="element-43">
                                  Descripción:
                                </span>{' '}
                                {bono.desc}
                              </p>
                            </div>
                            <div className="bg-lightbg rounded-lg p-4 border border-gray-200" data-id="element-44">
                              <p className="text-navy text-sm font-medium leading-relaxed" data-id="element-45">
                                <span className="font-bold text-celeste uppercase text-xs tracking-wider block mb-1" data-id="element-46">
                                  Resultado
                                </span>
                                {bono.resultado}
                              </p>
                            </div>
                            <div className="text-sm font-medium text-gray-500 pt-2" data-id="element-47">
                              Valor:{' '}
                              <span className="line-through" data-id="element-48">{bono.valor}</span>{' '}
                              <span className="text-gold font-bold ml-1" data-id="element-49">
                                → HOY GRATIS
                              </span>
                            </div>
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn data-id="element-50">
          <div className="flex justify-center" data-id="element-51">
            <div className="bg-navy text-white font-display font-bold text-sm md:text-base px-6 py-3 rounded-full shadow-lg border border-navy/50 text-center" data-id="element-52">
              Valor total: $19.950 ARS —{' '}
              <span className="text-celeste" data-id="element-53">
                Incluidos sin costo adicional
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}